module.exports = __webpack_public_path__ + "img/3-1.20e98ef9.svg";